export default "__VITE_ASSET__DMdjxi0J__"